//src/api/user.js
import api from './index';

export const verifyPassword = ({ phoneNumbers, password }) => api.post('/testapi/user/login_controller/check_password_for_login', {
  phoneNumbers,
  password
});


export const updateUserPassword = ({ phoneNumbers, password }) => api.post('/testapi/user/login_controller/update_password', {
  phoneNumbers,
  password
});

export const getUserProfile = ({ uid }) => api.post('/testapi/user/user_controller/authing_login', {
  uid // 发送 { uid: "some-uid-value" }
});


export const getWebInfo = ({ }) => api.post('/testapi/user/user_controller/web_info', {
   // 发送 { uid: "some-uid-value" }
});



// 新增接口：通过 url_login_token 获取用户信息
export const getUserProfileByToken = ({ url_login_token }) => api.post('/testapi/user/user_controller/login_by_token', { url_login_token });

export const login = ({ uid }) => api.post('/testapi/user/user_controller/authing_login', {
  uid // 发送 { uid: "some-uid-value" }
});

export const login_new = ({ uid }) => api.post('/testapi/user/user_controller/authing_login_new', {
  uid // 发送 { uid: "some-uid-value" }
});



export const getCaptcha = (email) => api.post('/testapi/user/login_controller/send_email_for_login', {
  phoneNumbers: email
});


export const getSmsCaptcha = (email) => api.post('/testapi/user/login_controller/send_sms_for_login_test', {
  phoneNumbers: email
});

export const verifyCaptcha = ({ phoneNumbers, smsCode }) => api.post('/testapi/user/login_controller/check_smscode_for_login_test', {
  phoneNumbers,
  smsCode
});